export const eventTypes = {
  EVENT: "EVENT",
};

const createMilestoneAndTaskEvent = (event, item) => {
  return {
    title: event.data?.name,
    status: event.data?.statusData,
    label: event.data?.serviceData.name,
    subTitle: event.data?.owner,
    start: new Date(event.data?.due_date),
    end: new Date(event.data?.due_date),
    type: eventTypes.EVENT,
    backgroundColor: event.data?.serviceData.secondary_color,
    color: event.data?.serviceData.primary_color,
    process: event.data?.processData?.id,
    id: event.type === "Milestones" ? event.data?.id : event.data?.milestone,
    filterType: event.type,
    totalCount: item.totalCount,
    due_date_utc: new Date(event.data?.due_date),
    entityData: event.data?.processData?.entityData,
    processData: event.data?.processData,
  };
};

export const convertDataToCalendarEvents = (data = []) => {
  const events = [];
  data.forEach((item) => {
    item.items.forEach((event) => {
      if (event) {
        events.push(createMilestoneAndTaskEvent(event, item));
      }
    });
  });

  return events;
};
